exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.van-radio__label {\r\n  margin-left: 2px !important;\n}\r\n", ""]);

// exports
